import { render, staticRenderFns } from "./EditWrapping.vue?vue&type=template&id=b568ca06"
import script from "./EditWrapping.vue?vue&type=script&lang=js"
export * from "./EditWrapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports